/* jshint esversion: 6 */

let labels = {
    1: { // Twitter
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'alt_text': {
            'fieldName': 'alt_text',
            'fieldLabel': 'Alt Text'
        },
        'postQrCode': {
            'fieldName': 'Add a QR Code for the Link',
            'fieldLabel': 'Add a QR Code for the Link'
        },
        'postDarkQR': {
            'fieldName': 'Use Dark Mode QR Cards',
            'fieldLabel': 'Use Dark Mode QR Cards'
        },

    },
    2: { //Facebook
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'link': {
            'fieldName': 'URL',
            'fieldLabel': 'Link'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'publishAsStory': {
            'fieldName': 'Publish As Story',
            'fieldLabel': 'Publish As Story'
        },
        'publishAsReel': {
            'fieldName': 'Publish As Reel',
            'fieldLabel': 'Publish As Reel'
        }
    },
    3 : { // Tumblr
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'title': {
            'placeholder': 'Title',
            'fieldName': 'title',
            'fieldLabel': 'Title'
        },
        'link': {
            'fieldName': 'URL',
            'fieldLabel': 'Link',
            'placeholder': 'Link'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'body': {
            'placeholder': 'Link Summary',
            'fieldName': 'body',
            'fieldLabel': 'Link Summary'
        },
    },
    4 : { // LinkedIn
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'link': {
            'fieldName': 'URL',
            'fieldLabel': 'Link'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'alt_text': {
            'fieldName': 'alt_text',
            'fieldLabel': 'Alt Text'
        }
    },
    5: { // Pinterest
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'title': {
            'placeholder': 'Title',
            'fieldName': 'title',
            'fieldLabel': 'Title'
        },
        'link': {
            'fieldName': 'URL',
            'fieldLabel': 'Link',
            'placeholder': 'Link'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'alt_text': {
            'fieldName': 'alt_text',
            'fieldLabel': 'Alt Text'
        }
    },
    7: { // RSS Feed
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'title': {
            'placeholder': 'Title',
            'fieldName': 'title',
            'fieldLabel': 'Title'
        },
        'link': {
            'fieldName': 'URL',
            'fieldLabel': 'Link'
        }
    },
    8: { // Instagram
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'publishAsStory': {
            'fieldName': 'Publish As Story',
            'fieldLabel': 'Publish As Story'
        },
        'postQrCode': {
            'fieldName': 'Add a QR Code for the Link',
            'fieldLabel': 'Add a QR Code for the Link'
        }
    },
    20: { // Google
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'alert_type': {
            'fieldName': 'Alert Type',
            'fieldLabel': 'Alert Type',
            'placeholder': 'Alert Type',
            'defaultSelect': 'Alert Type'
        },
        'couponCode': {
            'fieldName': 'Coupon Code',
            'placeholder': 'Coupon Code',
            'fieldLabel': 'Coupon Code'
        },
        'cta_type': {
            'fieldName': 'Button Type',
            'fieldLabel': 'Button Type',
            'placeholder': 'Button Type'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'link': {
            'fieldName': 'URL',
            'placeholder': 'Button Link',
            'fieldLabel': 'Button Link'
        },
        'schedule': {
            'fieldName': 'Schedule',
            'fieldLabel': 'Schedule'
        },
        'termsConditions': {
            'fieldName': 'Terms & Conditions',
            'placeholder': 'Terms & Conditions',
            'fieldLabel': 'Terms & Conditions'
        },
        'title': {
            'placeholder': 'Title',
            'fieldName': 'title',
            'fieldLabel': 'Title'
        }
    },
    22: { // StockTwits
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'sentiment': {
            'fieldName': 'sentiment',
            'defaultSelect': 'Sentiment',
            'fieldLabel': 'Sentiment',
            'placeholder': 'Sentiment'
        }
    },
    23: { // Slack
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'title': {
            'placeholder': 'Title',
            'fieldName': 'title',
            'fieldLabel': 'Title'
        },
        'body': {
            'placeholder': 'Link Summary',
            'fieldName': 'body',
            'fieldLabel': 'Link Summary'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'link': {
            'fieldName': 'URL',
            'fieldLabel': 'Link',
            'placeholder': 'Link'
        }
    },
    24: { // Discord
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'title': {
            'placeholder': 'Title',
            'fieldName': 'title',
            'fieldLabel': 'Title'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'link': {
            'fieldName': 'URL',
            'fieldLabel': 'Link'
        }
    },
    30: { // Blogger
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'title': {
            'placeholder': 'Title',
            'fieldName': 'title',
            'fieldLabel': 'Title'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'link': {
            'fieldName': 'URL',
            'fieldLabel': 'Link'
        }
    },
    35: { // Wordpress
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'title': {
            'placeholder': 'Title',
            'fieldName': 'title',
            'fieldLabel': 'Title'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'link': {
            'fieldName': 'URL',
            'fieldLabel': 'Link'
        },
        'alt_text': {
            'fieldName': 'alt_text',
            'fieldLabel': 'Alt Text'
        }
    },
    36: { // Reddit
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'title': {
            'placeholder': 'Title',
            'fieldName': 'title',
            'fieldLabel': 'Title'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'link': {
            'fieldName': 'URL',
            'fieldLabel': 'Link',
            'placeholder': 'Link'
        }
    },
    37: { // Mastodon
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        }
    },
    38: { // TikTok
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'video_title': {
            'fieldName': 'video_title',
            'fieldLabel': 'Video Title',
            'placeholder': 'Video Title'
        },
        'photo_title': {
            'fieldName': 'photo_title',
            'fieldLabel': 'Photo Title',
            'placeholder': 'Photo Title'
        },
        'disable_comment': {
            'fieldName': 'disable_comment',
            'fieldLabel': 'Disable Comment',
            'placeholder': 'Disable Comment'
        },
        'disable_stitch': {
            'fieldName': 'disable_stitch',
            'fieldLabel': 'Disable Stitch',
            'placeholder': 'Disable Stitch'
        },
        'disable_duet': {
            'fieldName': 'disable_duet',
            'fieldLabel': 'Disable Duet',
            'placeholder': 'Disable Duet'
        },
        'brand_content_toggle': {
            'fieldName': 'brand_content_toggle',
            'fieldLabel': 'Your Brand',
            'placeholder': 'Your Brand'
        },
        'brand_organic_toggle': {
            'fieldName': 'brand_organic_toggle',
            'fieldLabel': 'Branded Content',
            'placeholder': 'Branded Content'
        },
        'cover_ms': {
            'fieldName': 'cover_ms',
            'fieldLabel': 'Cover Image',
            'placeholder': 'Cover Image'
        }
    },
    39: { //Bluesky
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'link': {
            'placeholder': 'URL',
            'fieldName': 'URL',
            'fieldLabel': 'Link'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'alt_text': {
            'fieldName': 'alt_text',
            'fieldLabel': 'Alt Text'
        }
    },
    40: { // Nextdoor
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        }
    },
    41: { // YouTube
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Video'
        },
        'video_title': {
            'fieldName': 'video_title',
            'fieldLabel': 'Video Title',
            'placeholder': 'Video Title'
        },
        'video_description': {
            'fieldName': 'video_description',
            'fieldLabel': 'Video Description',
            'placeholder': 'Video Description'
        },
        'privacy_status': {
            'fieldName': 'privacy_status',
            'fieldLabel': 'Privacy Setting',
            'placeholder': 'Privacy Setting'
        },
        'category': {
            'fieldName': 'category',
            'fieldLabel': 'Category',
            'placeholder': 'Category'
        },
        'tags': {
            'fieldName': 'tags',
            'fieldLabel': 'Tags',
            'placeholder': 'Tags'
        },
        'license': {
            'fieldName': 'license',
            'fieldLabel': 'License',
            'placeholder': 'License'
        },
        'embeddable': {
            'fieldName': 'embeddable',
            'fieldLabel': 'Embeddable',
            'placeholder': 'Embeddable'
        },
        'made_for_kids': {
            'fieldName': 'made_for_kids',
            'fieldLabel': 'Made for Kids',
            'placeholder': 'Made for Kids'
        },
        'notify_subs': {
            'fieldName': 'notify_subs',
            'fieldLabel': 'Notify Subscribers',
            'placeholder': 'Notify Subscribers'
        },
        'playlists': {
            'fieldName': 'playlists',
            'fieldLabel': 'Playlists - optional',
            'placeholder': 'Playlists - optional'
        },
    },
    42: { // Threads
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': 'Image or Video'
        },
        'link': {
            'fieldName': 'URL',
            'fieldLabel': 'Link'
        }
    },
    43: { // Snapchat
        'message': {
            'placeholder': 'What would you like to share',
            'fieldName': 'message',
            'fieldLabel': 'Message'
        },
        'mb_id': {
            'fieldName': 'attachment',
            'fieldLabel': '(Story) Image or Video, (Spotlight Post) Video'
        },
    }
};

const LabelLibrary = {
    getStringsForField: (service, field, which) => {
        let label = '';

        if (labels[service] !== undefined) {
            if (labels[service][field] !== undefined) {
                if (labels[service][field][which] !== undefined) {
                    label = labels[service][field][which];
                }
            }
        }

        return label;
    }
};

export default LabelLibrary;
